<template>
  <div class="pa-5">
    <v-card class="overflow-y-auto elevation-0 rounded-lg" max-height="600">
      <v-card-text
        class="black--text"
        v-for="(item, i) in GroupConsent"
        :key="i.FirstNameTh"
      >
        <v-layout row wrap justify-start align-center>
          <v-flex xs11 md11 lg11>
            <b>{{ $t("dashboard.subject") }}</b> {{ item.GroupName }}
          </v-flex>
          <v-flex xs11 md11 lg11>
            <b>{{ $t("dashboard.cby") }}</b>
            <span v-if="$t('default') === 'th'">
              {{ item.FirstNameTh }} {{ item.LastNameTh }}
            </span>
            <span v-else>{{ item.FirstNameEng }} {{ item.LastNameEng }}</span>
          </v-flex>
          <v-flex xs11 md4 lg4> </v-flex>
        </v-layout>
        <v-flex xs11 md4 lg4>
          <b>{{ $t("dashboard.use") }}</b> {{ item.Consent.All }}
          {{ $t("dashboard.list") }}
        </v-flex>
        <v-layout row wrap justify-start align-center pt-2 pb-5>
          <v-flex xs11 md3 lg3>
            <v-chip color="teal lighten-5" small class="teal--text">
              {{ $t("dashboard.app") }}</v-chip
            >
            {{ item.Consent.Approve }} {{ $t("dashboard.list") }}
          </v-flex>
          <v-flex xs11 md3 lg3>
            <v-chip color="red lighten-5" class="red--text" small>{{
              $t("dashboard.reject")
            }}</v-chip>
            {{ item.Consent.Unapprove }} {{ $t("dashboard.list") }}
          </v-flex>
          <v-flex xs11 md3 lg3>
            <v-chip color="orange lighten-5" class="orange--text" small>{{
              $t("dashboard.pen")
            }}</v-chip>
            {{ item.Consent.Wait }} {{ $t("dashboard.list") }}
          </v-flex>
          <v-flex xs11 md3 lg3 text-center>
            <v-btn
              dense
              dark
              color="#077893"
              @click="Fn_GetDetail(item)"
              v-on:click="Fn_DetailGroup"
            >
              {{ $t("consentlist.detail") }}
            </v-btn>
          </v-flex>
        </v-layout>
        <hr class="line" />
      </v-card-text>
    </v-card>
    <div v-if="loadingDownloadData">
      <OverlaySearch />
    </div>
    <DialogDashboardDetail
      :show="DialogGeneral"
      :_header="Headers"
      :_detail="GroupDetail"
      @closeDialog="DialogGeneral = false"
    />
  </div>
</template>

<script>
import OverlaySearch from '@/components/layouts/LoadingPage.vue'
import DialogDashboardDetail from "@/components/dialog/DialogDashboardGroupConsentDetail";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { DialogDashboardDetail, OverlaySearch },
  data() {
    return {
      loadingDownloadData: false,
      GroupConsent: [],
      DialogGeneral: false,
      GroupDetail: [],
    };
  },
  methods: {
    Fn_GetGroupConsent() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        Type: "Group",
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "dashbord/ListConsent",
          payload
        )
        .then((response) => {
          this.loadingDownloadData = false;
          if (response.data.Status === "OK") {
            this.GroupConsent = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            // Toast.fire({
            //   icon: "error",
            //   title:  + error.message || error,
            // });

          }
        });
    },
    Fn_GetDetail(val) {
      this.$store.dispatch("SET_DATACONSENTID", val);
      this.$cookies.set("IDgroup", val.GroupId);
      this.$router.push("/data-group-detail");

    },
    Fn_DetailGroup() {
      // this.DialogGeneral = true;
    },
  },
  computed: {
    ...mapGetters(["Profile"]),
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),

    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    _SelectBusinessId: {
      get() {
        return this.Business.BusinessId || "-";
      },
    },
    _SelectBusinessNameTH: {
      get() {
        return this.Business.BusinessNameTH || "-";
      },
    },
    Headers() {
      return [
        {
          text: this.$i18n.t("dashboard.num"),
          align: "start",
          sortable: false,
          value: "no",
        },
        {
          text: this.$i18n.t("consentlist.type"),
          value: "SourceSystem",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("dashboard.name"),
          value: "Name",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("dashboard.email"),
          value: "Email",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("dashboard.create"),
          value: "SendAt",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("dashboard.detailtable"),
          value: "DetailSend",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("dashboard.status"),
          value: "Status",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
  mounted() {
    this.Fn_GetGroupConsent();
  },
};
</script>

<style scoped>
hr.line {
  border: 1px solid #077893;
}
</style>
